import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Sticky from 'react-sticky-el';

import Crown from '../../../images/pcma-crown.svg';
import Arrow from '../../../images/chart_arrow.png';

export const TabPanel = styled.div``;

export const StyledImageContainer = styled.div`
  position: relative;
  width: 50%;
  padding-top: 20px;
`;

export const StyledImage = styled.img`
  width: 25%;
  position: absolute;
  bottom: 5%;

  @media only screen and (min-width: ${themeGet(
      'breakpoints.md',
    )}) and (max-width: ${themeGet('breakpoints.lg')}) {
    width: 20%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 13%;
    position: absolute;
    right: -55%;
  }
`;

export const ChartHeading = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.pcma-chart,
  &.single-table {
    display: flex;
    flex-direction: cloumn;
    justify-content: center;
    align-items: center;

    margin-bottom: 4rem;
  }

  &.left {
    text-align: left;
  }

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }

  span {
    font-size: inherit;
    font-weight: inherit;

    &.crown {
      &:before {
        content: '';
        display: block;
        background-image: url(${Crown});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        height: 12.5%;
        width: 12.5%;
        left: 50%;
        top: -9.5%;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        &:before {
          top: -12.5%;
        }
      }
    }

    &.arrow-down {
      display: inline-flex;
      flex-direction: column;
      margin-bottom: -3rem;
      &:after {
        content: '';
        display: block;
        background-image: url(${Arrow});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        width: 145px;
        height: 60px;
        margin: auto;
        margin-top: 10px;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        &:after {
          width: 180px;
          height: 70px;
        }
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        &:after {
          width: 210px;
          height: 95px;
        }
      }
    }
  }
`;

export const ChartWrapper = styled.table`
  width: 100%;
  table-layout: fixed;
  position: relative;

  &.row-layout-chart {
    + div {
      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        margin: 0 auto;
      }
    }

    &:after {
      content: '';
      border-bottom: 2px solid ${themeGet('colors.light-border-grey')};
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 2px;
      display: block;
    }
  }

  .sr-only {
    clip: rect(0px, 0px, 0px, 0px);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  &.selectable-card {
    background: linear-gradient(
      to right,
      ${themeGet('colors.chart-pink')} 50%,
      ${themeGet('colors.light-border-grey')} 50% 100%
    );
    &.v2 {
      background: ${themeGet('colors.white')};
    }
    border-radius: 0 0 6px 6px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background: none;
      border-radius: 0;
    }
  }

  &.pcma-chart {
    background: linear-gradient(
      to right,
      ${themeGet('colors.chart-pink')} 50%,
      ${themeGet('colors.velvet')} 50% 100%
    );
    border-radius: 20px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background: none;
      border-radius: 0;
    }
  }

  &.single-table {
    width: 100%;
    margin: auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 80%;
    }
  }

  &.selectable-card.v2 {
    background-color: ${themeGet('colors.light-border-grey')}
    border-radius: 0 0 6px 6px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background: none;
      border-radius: 0;
    }
  }
`;

export const ChartIntro = styled.div`
  margin-bottom: 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 2rem;
  }

  p {
    font-size: 1rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1.25rem;
      line-height: 1.25rem;
    }
  }

  &.left {
    text-align: left;
  }

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }
`;

export const Caption = styled.caption`
  margin-bottom: 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 2rem;
  }
`;

export const Wrapper = styled.tr`
  position: relative;
  margin: 0;
  width: 100%;
  display: block;

  &.v2:not(:last-child) {
    border-bottom: 1px solid ${themeGet('colors.light-border-grey')};

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      border-bottom: none;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: table-row;
  }

  &.selectable-card {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      &:nth-child(1) {
        th,
        td {
          padding-top: 2rem;

          &:before {
            margin-top: 2rem;
          }
        }

        td {
          border-radius: 0 6px 0 0;

          &:nth-child(2).optimum,
          &:last-child {
            border-radius: 0;
          }
        }
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      &:nth-child(1) {
        th,
        td {
          padding-top: 3.75rem;

          &:before {
            margin-top: 3.75rem;
          }
        }
      }
    }

    &:last-child {
      td {
        border-radius: 0 0 6px 6px;

        @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
          border-radius: 0 0 6px 0;
        }

        &:nth-child(2) {
          border-radius: 0 0 0 6px;
        }

        &.is-not-active {
          border-radius: 0;
        }

        div {
          background-color: transparent;
        }
      }
    }
  }

  // Removes border on <td>'s that appear below a vendor row as vendor row doesn't have a bg color applied to it
  &.vendors-cell {
    & + .points-cell,
    & + .default-cell,
    & + .feature-cell {
      td {
        &:before {
          display: none;
        }
      }
    }
  }

  &.pcma-chart {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      &:nth-child(1) {
        td {
          &:last-child {
            border-radius: 0 20px 0 0;
          }
        }
      }
    }
  }

  &.single-table {
    display: flex;
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      display: table-row;
    }
  }

  &.points-section {
    display: table-row;
  }
`;

export const StyledSticky = styled(Sticky)`
  div.mobile-landscape {
    div.carousel-ctrls {
      top: 63%;
    }
  }
`;

export const THead = styled.thead`
  & > tr {
    & > th {
      &:first-child {
        & > div {
          & > div {
            & > div {
              &:not(.column-layout-chart, .selectable-card) {
                * {
                  clip: rect(0 0 0 0);
                  clip-path: inset(50%);
                  height: 1px;
                  overflow: hidden;
                  position: absolute;
                  white-space: nowrap;
                  width: 1px;
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const TBody = styled.tbody`
  ${Wrapper}.chart.feature-cell {
    &:last-child {
      margin-bottom: 15px;
    }
  }
  ${Wrapper}.selectable-card {
    &:last-child {
      th {
        &:before {
          border-top: 2px solid ${themeGet('colors.white')};

          @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
            border-top: 2px solid ${themeGet('colors.light-border-grey')};
          }
        }
      }

      td {
        width: 100%;
      }
      td:nth-child(2).optimum {
        display: none;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      &:last-child {
        td:nth-child(2).optimum {
          display: table-cell;
          background: ${themeGet('colors.chart-pink')};
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${Wrapper}.chart.feature-cell {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

export const Footnote = styled.div`
  border: 1px solid ${themeGet('colors.border-grey')};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 1rem;
  margin: 0 0 2rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: ${props =>
      // eslint-disable-next-line no-nested-ternary
      props.columnCount === '3'
        ? props.className === 'column-layout-chart'
          ? '2rem 0'
          : '2rem 0 2rem calc(100% / 3)'
        : `2rem 0 2rem calc(100% / ${props.columnCount})`};
  }
`;

export const Footer = styled.div`
  padding: 2rem 0;
  display: flex;
  justify-content: center;
`;
